export default __webpack_public_path__ + "static/media/FP-2.4085c6e5.png";